import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-bae9ed70"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "table-container" }
const _hoisted_2 = { class: "flex justify-between align-center" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "table" }
const _hoisted_5 = { class: "bold text-muted" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "flex align-center" }
const _hoisted_8 = { class: "flex justify-between align-center" }
const _hoisted_9 = { class: "subtitle" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "icon-container" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  width: "100",
  src: "ico/store2.svg"
}, null, -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { class: "flex col" }
const _hoisted_15 = { class: "flex align-center justify-between w100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SeButton = _resolveComponent("SeButton")!
  const _component_ToggleSwitch = _resolveComponent("ToggleSwitch")!
  const _component_SeInput = _resolveComponent("SeInput")!
  const _component_SeFadeButton = _resolveComponent("SeFadeButton")!
  const _component_SeModal = _resolveComponent("SeModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_SeModal, {
      title: "Prices",
      ref: "pricesModal"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.Lang.getI18N("price")), 1),
            _createVNode(_component_SeButton, {
              onPress: _ctx.savePrices,
              ref: "savePriceBtn",
              icon: "ico/save.svg"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("apply")), 1)
              ]),
              _: 1
            }, 8, ["onPress"])
          ]),
          _createElementVNode("table", _hoisted_4, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, _toDisplayString(_ctx.Lang.getI18N("database")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.Lang.getI18N("active")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.Lang.getI18N("image")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.Lang.getI18N("name")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.Lang.getI18N("description")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.Lang.getI18N("price")) + " (€)", 1)
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.databaseShopItems, (databaseItem) => {
              return (_openBlock(), _createElementBlock("tr", null, [
                _createElementVNode("td", null, [
                  _createElementVNode("span", _hoisted_5, _toDisplayString(databaseItem[0].name), 1)
                ]),
                _createElementVNode("td", null, [
                  _createVNode(_component_ToggleSwitch, {
                    defaultValue: databaseItem[1].getActive(),
                    modelValue: databaseItem[1].active,
                    "onUpdate:modelValue": ($event: any) => ((databaseItem[1].active) = $event)
                  }, null, 8, ["defaultValue", "modelValue", "onUpdate:modelValue"])
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("img", {
                    width: "40",
                    src: databaseItem[1].getIllustration()
                  }, null, 8, _hoisted_6)
                ]),
                _createElementVNode("td", null, _toDisplayString(databaseItem[1].getName()), 1),
                _createElementVNode("td", null, _toDisplayString(databaseItem[1].getDescription()), 1),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_SeInput, {
                      value: databaseItem[1].getPrice(),
                      modelValue: databaseItem[1].price,
                      "onUpdate:modelValue": ($event: any) => ((databaseItem[1].price) = $event),
                      numberOnly: true
                    }, null, 8, ["value", "modelValue", "onUpdate:modelValue"]),
                    (databaseItem[1].price != null)
                      ? (_openBlock(), _createBlock(_component_SeFadeButton, {
                          key: 0,
                          icon: "/ico/refresh.svg",
                          onClick: ($event: any) => (databaseItem[1].price = null)
                        }, null, 8, ["onClick"]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            }), 256))
          ])
        ])
      ]),
      _: 1
    }, 512),
    _createElementVNode("div", {
      class: _normalizeClass('shop-item ' + (_ctx.shopItem.active ? '' : 'unactive'))
    }, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.shopItem.name), 1),
        _createVNode(_component_ToggleSwitch, {
          modelValue: _ctx.shopItem.active,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.shopItem.active) = $event))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("active")), 1)
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createElementVNode("div", {
        onClick: _cache[1] || (_cache[1] = () => _ctx.pickIllustration(_ctx.shopItem)),
        class: "flex align-center justify-center shop-illustration"
      }, [
        _withDirectives(_createElementVNode("img", {
          style: {"border-radius":"12px"},
          height: "150",
          ref: "illustration",
          src: _ctx.shopItem.illustration!
        }, null, 8, _hoisted_10), [
          [_vShow, _ctx.hasIllustration]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_11, _hoisted_13, 512), [
          [_vShow, !_ctx.hasIllustration]
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_SeInput, {
          class: "grow",
          background: "#f3fafa",
          modelValue: _ctx.shopItem.name,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.shopItem.name) = $event)),
          placeholder: _ctx.Lang.getI18N('name')
        }, null, 8, ["modelValue", "placeholder"]),
        _createVNode(_component_SeInput, {
          class: "grow",
          background: "#f3fafa",
          modelValue: _ctx.shopItem.description,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.shopItem.description) = $event)),
          placeholder: _ctx.Lang.getI18N('description')
        }, null, 8, ["modelValue", "placeholder"]),
        _createVNode(_component_SeInput, {
          class: "grow",
          numberOnly: true,
          background: "#f3fafa",
          modelValue: _ctx.shopItem.price,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.shopItem.price) = $event)),
          placeholder: _ctx.Lang.getI18N('price')
        }, null, 8, ["modelValue", "placeholder"]),
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_SeFadeButton, {
            onClick: _ctx.onMoveLeft,
            icon: "/ico/arrow-right.svg"
          }, null, 8, ["onClick"]),
          _createVNode(_component_SeButton, {
            ref: "openPriceBtn",
            onPress: _ctx.openPrices,
            class: "w100",
            icon: "/ico/eye.svg"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("price")), 1)
            ]),
            _: 1
          }, 8, ["onPress"]),
          _createVNode(_component_SeFadeButton, {
            onClick: [
              _ctx.onMoveRight,
              _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
            ],
            icon: "/ico/arrow-left.svg"
          }, null, 8, ["onClick"])
        ])
      ])
    ], 2)
  ], 64))
}